import type { StorageLocationsSortBy } from 'src/apis/storage/types';

export const storageLocationsSortByValues = [
  'NAME',
  'LOCATION_BUSINESS_ID',
  'MARKET_AREA',
  'SSO_NAME',
] as const satisfies readonly StorageLocationsSortBy[];
